import * as React from "react";
import styled from "styled-components";
import image from "src/assets/images/mobile_thumb@2x.png";

const Container = styled.div`
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
`;

const Image = styled.img`
  position: absolute;
  height: 100%;
  @media screen and (orientation: landscape) {
    width: 100%;
    height: auto;
  }
`;

class Fallback extends React.Component {
  public render() {
    return (
      <Container>
        <Image
          src={image}
          alt="Sportec Solutions Eco System"
          aria-label="Sportec Solutions Ecosystem"
        />
      </Container>
    );
  }
}

export default Fallback;



// WEBPACK FOOTER //
// ./src/modules/Fallback.tsx